import classNames from 'classnames';
import { useMemo, useState } from 'react';
import Description from './Description';
import NavTab from './NavTab';
import ImageSlider from './ImageSlider';
import {
  matchesCondition,
  type ResolvedConditions,
} from '@/lib/use-category-conditions';

const Content = ({
  activeCondition,
  conditionsContent,
}: {
  activeCondition: string;
  conditionsContent: ResolvedConditions | undefined;
}) => {
  const [currentCondition, setCurrentCondition] = useState(activeCondition);

  const activeIndex = useMemo(
    () =>
      Math.max(
        0,
        conditionsContent?.options.findIndex((option) =>
          matchesCondition(option, currentCondition),
        ) ?? 0,
      ),
    [conditionsContent, currentCondition],
  );

  const activeOption = conditionsContent?.options[activeIndex];
  const conditionImages = activeOption?.imageUrls ?? [];

  const sliderPreset = !!(conditionImages && conditionImages.length > 0);

  return (
    <div className="relative flex-1 overflow-y-auto px-4 pt-6 sm:px-6">
      {conditionsContent?.options.map((condition, index) => (
        <div
          key={condition.name}
          // eslint-disable-next-line tailwindcss/no-custom-classname, tailwindcss/migration-from-tailwind-2
          className={classNames(
            'z-10 h-full bg-white ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
            {
              hidden: activeIndex !== index,
            },
          )}
        >
          <ul className="h-full">
            <li
              key={condition.name}
              className="relative inline-block h-full w-full"
            >
              <div className="flex h-full flex-col">
                <ImageSlider
                  conditionImages={conditionImages}
                  condition={condition.name}
                  sliderPreset={sliderPreset}
                />

                <NavTab
                  currentCondition={currentCondition}
                  setCurrentCondition={setCurrentCondition}
                  conditions={conditionsContent.options}
                />

                <Description
                  sliderPreset={sliderPreset}
                  description={condition.description}
                />
              </div>
            </li>
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Content;
